import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';

import config from '../config/config';

// const apiMealEndpoint = '/api/meal/';
const apiToken = process.env.REACT_APP_API_TOKEN;
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/eating?secret_key=${apiToken}`);
	
const slice = createSlice({
  name: 'eating',
  initialState: {
    list: [],
  },
  reducers: {
    // { id: 1, name: 'Первое', price: 200, mealTypeId: 1,isCombo:2},

    eatingReceived: (eating, action) => {
      eating.list = action.payload.data;
      // meal.list = [];
      // action.payload.data.forEach(m => {
      //   meal.list.unshift({
      //     id: m.id,
      //     name: m.name,
      //     price: m.price,
      //     mealTypeId:m.mealtype_id,
      //     isCombo:m.is_combo ? 1 : 2,
      //     comboMeals: m.combo_meals[0].mealcombo_id !== null ? m.combo_meals : [],
      //   });
      // });
    },

    // mealAdded: (meal, action) => {
    //   // console.log('mealAdded',meal, action);
    //   meal.list.push({
    //     ...action.payload.params.meal,
    //     id: action.payload.data.id        
    //   });
    // },

    // mealComboAdded: (meal, action) => {
    //   // console.log('mealComboAdded',meal, action);
    //   const {mealId, comboId} = action.payload.params
    //   const index = meal.list.findIndex(m => m.id === comboId);
    //   meal.list[index].comboMeals.unshift({meal_id: mealId, mealcombo_id: action.payload.data.mealcombo_id })

    // },

    // mealComboDeleted: (meal, action) => {
    //   console.log('mealComboDeleted',meal, action);
    //   const {mealComboId, comboId} = action.payload.params
    //   const index = meal.list.findIndex(m => m.id === comboId);
    //   meal.list[index].comboMeals = meal.list[index].comboMeals.filter(n => n.mealcombo_id !== mealComboId)
    // },

    // mealChanged: (meal, action) => {
    //   // console.log('mealAdded',meal, action);
    //   const {meal: newMeal} = action.payload.params
    //   const index = meal.list.findIndex(m => m.id === newMeal.id);
    //   meal.list[index] = newMeal;

    //   // meal.list.push({
    //   //   ...action.payload.params.meal,
    //   //   id: action.payload.data.id        
    //   // });
    // },

    // mealDeleted: (meal, action) => {
    //   meal.list = meal.list.filter(n => n.id !== action.payload.params.mealId)
    // },


  }
});

const { eatingReceived } = slice.actions;
export default slice.reducer;

// Action Creators
// const eventId = config.eventId
// const  {data}  = await http.get(`${apiEventEndpoint}${eventId}/eating?secret_key=${apiToken}`);

export const loadEating = () => async (dispatch, getState) => {
  const eventId = config.eventId
  return await dispatch(
    apiCallBegan({
      url: `/api/meal/eating?secret_key=${apiToken}`,
      onSuccess: eatingReceived.type,
      actionName: 'loadEating',
    })
  );
};


// export const addMeal = meal =>
//   apiCallBegan({
//     url: `/api/meal/?secret_key=${apiToken}`,
//     method: 'post',
//     data: {  meal },
//     onSuccess: mealAdded.type,
//     actionName: 'addMeal',
//     params: { meal }
//   });


//   export const changeMeal = meal =>
//   apiCallBegan({
//     url: `/api/meal/?secret_key=${apiToken}`,
//     method: 'put',
//     data: {  meal },
//     onSuccess: mealChanged.type,
//     actionName: 'changeMeal',
//     params: { meal }
//   });


//   export const delMeal = mealId =>
//   apiCallBegan({
//     url: `/api/meal/${mealId}/?secret_key=${apiToken}`,
//     method: 'delete',
//     onSuccess: mealDeleted.type,
//     actionName: 'delMeal',
//     params: { mealId }
//   });


//   export const addMealCombo = ({mealId, comboId}) =>
//   apiCallBegan({
//     url: `/api/meal/combo/?secret_key=${apiToken}`,
//     method: 'post',
//     data: {  mealId, comboId },
//     onSuccess: mealComboAdded.type,
//     actionName: 'addMealCombo',
//     params: { mealId, comboId }
//   });

//   export const deleteMealCombo = ({mealComboId,comboId}) =>
//   apiCallBegan({
//     url: `/api/meal/combo/${mealComboId}/?secret_key=${apiToken}`,
//     method: 'delete',
//     onSuccess: mealComboDeleted.type,
//     actionName: 'deleteMealCombo',
//     params: { mealComboId,comboId }
//   });


  

// Selectors

export const getEatingSelector = createSelector(
  state => state.entities.eating.list,
  eating => eating
);
export const getEatingByNameSelector = name => createSelector(
  state => state.entities.eating.list,
  eating => eating.filter(e => e.name === name)[0]
);


// Helpers methods

